var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhiteWarningTick = function SvgWhiteWarningTick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47.479,
    height: 38.502,
    viewBox: "0 0 47.479 38.502",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18581",
    "data-name": "Group 18581",
    transform: "translate(-149.033 -70.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9704",
    "data-name": "Path 9704",
    d: "M36.438,23.9a5.783,5.783,0,0,1,0-4.226l.178-.445a5.664,5.664,0,0,0-2.879-7.265l-.391-.185a5.321,5.321,0,0,1-2.879-3L30.325,8.4a5.338,5.338,0,0,0-7-3l-.355.148a5.215,5.215,0,0,1-4.087,0l-.32-.148a5.291,5.291,0,0,0-6.93,3.04l-.142.3a5.321,5.321,0,0,1-2.879,3l-.32.148a5.681,5.681,0,0,0-2.843,7.265l.142.334a5.783,5.783,0,0,1,0,4.226l-.142.408a5.576,5.576,0,0,0,2.879,7.228l.355.148a5.321,5.321,0,0,1,2.879,3l.178.408a5.238,5.238,0,0,0,6.93,3.04l.391-.185a5.215,5.215,0,0,1,4.087,0l.32.148a5.27,5.27,0,0,0,6.966-3l.142-.3a5.321,5.321,0,0,1,2.879-3l.284-.111a5.619,5.619,0,0,0,2.879-7.265Zm-16.917,5h0l-6.93-6.079,2.132-2.632,4.407,3.892,7.783-9.638,2.523,2.224L19.521,28.9Z",
    transform: "translate(144 71.012)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Warning_911852",
    transform: "translate(396.172 255.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17741",
    "data-name": "Group 17741",
    transform: "translate(-214.997 -185.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17740",
    "data-name": "Group 17740",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10800",
    "data-name": "Path 10800",
    d: "M7.674,0a1.2,1.2,0,0,0-1,.506L.164,10.277a.9.9,0,0,0,0,1.024,1.193,1.193,0,0,0,1.007.506H14.176a1.193,1.193,0,0,0,1.007-.506.911.911,0,0,0,0-1.024L8.674.506A1.2,1.2,0,0,0,7.674,0Zm0,.622a.522.522,0,0,1,.4.2L14.584,10.6a.362.362,0,0,1,0,.385.54.54,0,0,1-.408.2H1.171a.529.529,0,0,1-.408-.2.362.362,0,0,1,0-.385L7.272.82A.522.522,0,0,1,7.674.622Zm0,2.642a.334.334,0,0,0-.352.308V7.921a.335.335,0,0,0,.352.314.329.329,0,0,0,.346-.314V3.573A.328.328,0,0,0,7.674,3.264Zm0,5.593a.469.469,0,1,0,0,.93.468.468,0,1,0,0-.93Z",
    transform: "translate(-0.004 0)",
    fill: "#f9f9f9"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteWarningTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whiteWarningTick.990522a1.svg";
export { ForwardRef as ReactComponent };